// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aX0U0","right":"styles_right__9Ou8M"};